module.exports = __webpack_public_path__ + "assets/img/qrcode.58c49397.png";